module.exports = __webpack_public_path__ + "static/border-control-teaser-66b435816aebd8f78b5c3ce6bd574782.jpg";